import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "steppableType",
    "steppableDropdown",
  ]

  connect() {
    this.updateControlVisibilities();
    this.hideAllDropdowns();
    this.setFormState();
    this.addFirstRowAssignment();
  }

  hideAllDropdowns() {
    this.steppableDropdownTargets.forEach(wrapper => {
      wrapper.classList.add('hidden');
    });
  }

  updateSteppableDropdown() {
    const selectedType = this.steppableTypeTarget.value

    this.steppableDropdownTargets.forEach(dropdown => {
      const id = dropdown.id || ''
      const matches = id.includes(this.toSnakeCase(selectedType))

      dropdown.classList.toggle('hidden', !matches)
    })
  }

  toSnakeCase(text) {
    let newText = text.replace(/([A-Z])/g, function($1) { return "_" + $1.toLowerCase(); });
    newText = newText.replace(/^_/, '');
    return newText;
  }

  setFormState() {
    const selectedType = this.steppableTypeTarget.value;
    const selectId = this.toSnakeCase(selectedType.replace(/ /g, "_")) + "_id";

    this.hideAllDropdowns();

    const selectWrapper = document.getElementById(selectId + "_wrapper");
    if (selectWrapper) {
      selectWrapper.classList.remove('hidden');
    }
  }

  updateControlVisibilities() {
    // sharedCheckbox will only be visible if forCirclesCheckbox is checked
    const forCirclesCheckbox = document.querySelector('input[name="milestone[for_circles]"]');
    const sharedCheckbox = document.querySelector('input[name="milestone[shared]"]');

    if (forCirclesCheckbox && sharedCheckbox) {
      const checked = forCirclesCheckbox.checked;
      if (!checked) {
        sharedCheckbox.checked = true;
      }
      sharedCheckbox.closest('.form-row').style.display = checked ? '' : 'none';
    }
  }

  addFirstRowAssignment() {
    const table = document.querySelector('table.milestone-assignments');
    if (table && table.querySelectorAll('.nested-fields').length < 1) {
      const addButton = document.querySelector('.button.add_fields');
      if (addButton) {
        addButton.click();
      }
    }
  }

  changeSteppableType() {
    this.setFormState();
  }

  changeForCircles() {
    this.updateControlVisibilities();
  }
}
